import React, { useState } from "react";
import { colors } from "../../../themes/Colors";

const IconOnlyButton = ({
  iconImage,
  height,
  width,
  onClick,
  label,
  marginRight,
  labelColor,
  widthScreen,
  backgroundColor,
  borderRadius,
  shadow,
  bottom,
  marginBottom,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        height: 50,
        width: label ? 100 : 50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderStyle: "none",
        backgroundColor: "transparent",
        flexDirection: "column",
        position: "relative",
        marginRight: marginRight ? marginRight : null,
        marginBottom: marginBottom,
      }}
    >
      <img
        alt="icon"
        src={iconImage}
        style={{
          height: hover ? (height ? height + 7 : 47) : height ? height : 40,
          width: hover ? (width ? width + 7 : 47) : width ? width : 40,
          transition: "all 0.2s",
          backgroundColor: backgroundColor ? backgroundColor : null,
          borderRadius: borderRadius ? borderRadius : 0,
          WebkitBoxShadow: shadow ? "-5px 5px 15px -1px #00000070" : null,
        }}
      />
      {label && widthScreen > 599 ? (
        <div
          style={{
            marginTop: 0,
            width: 120,
            position: "absolute",
            bottom: bottom,
            color: labelColor,
            fontWeight: "bold",
            fontSize: width > 599 ? 14 : 18,
          }}
        >
          {label}
        </div>
      ) : null}
    </button>
  );
};
export default IconOnlyButton;
